module.exports = __webpack_public_path__ + "static/media/release.1353b45c.png";